module.exports = __webpack_public_path__ + "img/v3.1.259143fd.png";